import { render } from "./DefaultPostMoreSectionVideoCmp.vue?vue&type=template&id=1eac5cf6"
import script from "./DefaultPostMoreSectionVideoCmp.vue?vue&type=script&lang=js"
export * from "./DefaultPostMoreSectionVideoCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__